// extracted by mini-css-extract-plugin
module.exports = {"heading":"_da3e7874","label":"_66fe96a8","text":"_814b3301","buttons":"_fbb0e85c"};